import type { FormValues, FormValuesEvent } from "@/widgets/classic-form/form";
import { EVENT_DEFAULT_INSTANCE } from "@/widgets/classic-form/form";
import { getEventModelName } from "@/entities/data-model";
import type { HierarchicalFieldGroup } from "@/entities/form-metadata";
import { LOCATION_EXACTNESS_SCOPE } from "@/entities/place";

const populateInstances = ({
    formValuesEventsData,
    eventKey,
    dataModelEvent,
    matchAllTermsExactly,
}: {
    formValuesEventsData: FormValues["events"];
    eventKey: string;
    dataModelEvent?: FormValuesEvent;
    matchAllTermsExactly: boolean;
}) => {
    if (formValuesEventsData[eventKey]?.instances.length) return;
    if (dataModelEvent && dataModelEvent.instances.length) {
        const instances = matchAllTermsExactly
            ? dataModelEvent.instances.map((instance) => ({
                  ...instance,
                  dateProximity: {
                      ...instance.dateProximity,
                      year: 0,
                  },
                  locationExactness: LOCATION_EXACTNESS_SCOPE.ThisPlace,
              }))
            : dataModelEvent.instances;
        formValuesEventsData[eventKey]?.instances.push(...instances);
    } else if (formValuesEventsData[eventKey]) {
        formValuesEventsData[eventKey].instances.push(EVENT_DEFAULT_INSTANCE);
    }
};

export const populateHierarchicalFields = ({
    fieldGroup,
    dataModel,
    formValuesEventsData,
    matchAllTermsExactly,
}: {
    fieldGroup: HierarchicalFieldGroup;
    dataModel: FormValues;
    formValuesEventsData: FormValues["events"];
    matchAllTermsExactly: boolean;
}) => {
    const { events: eventsFromDataModel } = dataModel;
    fieldGroup.hierarchies.forEach((hierarchy) => {
        const dynamicEventKey = getEventModelName({
            eventType: hierarchy.eventType,
            relation: hierarchy.relation,
        });
        if (!dynamicEventKey) return;
        const dataModelEvent = eventsFromDataModel[dynamicEventKey];
        if (!formValuesEventsData[dynamicEventKey]) {
            formValuesEventsData[dynamicEventKey] = {
                eventName: hierarchy.eventType as string,
                instances: [],
                relation: hierarchy.relation,
            };
        }
        populateInstances({ formValuesEventsData, eventKey: dynamicEventKey, dataModelEvent, matchAllTermsExactly });
    });
};
